import { DateTimeFormatService } from 'src/app/core/services/format.datetime.service';
import { Component, OnInit, Input, Renderer2, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataFormatNumberService } from 'src/app/core/services/data-format-number.service';
import { DataFormatService } from 'src/app/core/services/data-format.service';
import { DataService } from 'src/app/core/services/data.service';
import * as QRCode from 'qrcode-generator';
import { PME0611Req } from 'src/app/shared/models/track/pme0611-req';
import { PME0611Res } from 'src/app/shared/models/track/pme0611-res';
import { HttpClientService } from 'src/app/core/services/http-client.service';
import { ImagesConvertorService } from 'src/app/core/services/images-convertor.service';
import { PME0612Req } from 'src/app/shared/models/track/pme0612-req';
import { PME0612Res } from 'src/app/shared/models/track/pme0612-res';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
@Component({
  selector: 'app-reg1100',
  templateUrl: './reg1100.component.html',
  styleUrls: ['./reg1100.component.css']
})
export class REG1100Component implements OnInit {
  @ViewChild('merchantDropdownList') merchantDropdownList: DropDownListComponent;
  @Input() modal: any;
  isPhoneNumber = false;
  isPhoneNotFound = false;
  stepOne = false;
  stepTwo = false;
  stepThree = false;
  stepFour = false;
  searchPhoneNumberStatus: any;
  viewText: any;
  loading: boolean;
  statusData: any;
  merchantName: any = [];
  merchantStatus: any;
  phoneNumber: any;
  merchantRequestDate: any;
  merchantStatusStep: any;
  selectMerchantName: any = '';
  defaultMerchant: any;
  isButtonActive = false;
  merchantApplicationNoData: any = "hello";
  merchantQrData: any;
  merchantQrName: any;
  merchantQrId: any;
  merchantAcquiringBanks: any;
  merchantQrCurrencyCode: any;
  merchantBakongAccountID: any;
  arrayQrData: any[] = [];
  arrayCurrencyData: any[] = [];
  uniqueKey: any;
  selectedMerchant: any;
  myData: any = [];
  isNormalStatus = false;
  isRejectStatus = false;
  constructor(
    private dataService: DataService,
    private dataFormat: DataFormatService,
    private dataFormatInput: DataFormatNumberService,
    private renderer: Renderer2,
    private translate: TranslateService,
    private bizServer: HttpClientService,
    private dateTimeFormatService: DateTimeFormatService,
    private imageService: ImagesConvertorService,
  ) { }

  ngOnInit(): void {
    this.viewText = this.translate.instant( "REG1100" );
    if ( this.defaultMerchant ) {
      this.isButtonActive = true;
    }
  }

  close() {
    this.modal.close();
    this.dataService.scrollMessage( "close" );
  }

  onlyNumbers( event: number ) {
    this.dataFormatInput.onlyNumberFormat( event );
  }

  // formatPhoneNumber( event: any ) {
  //   let tmp = this.searchPhoneNumberStatus.replace(/ /g, '');
  //   this.searchPhoneNumberStatus = this.dataFormat.formatPhone( tmp, event );
  // }

  // formatPhoneNumber( e:any ) {
  //   let regex: any =/^0/;
  //   let tmp = this.searchPhoneNumberStatus.replace(/ /g, '');
  //   let numFormat = this.dataFormat.formatPhone( tmp, e );
  //   if ( numFormat === "" && !regex.test( e.key ) ) {
  //       e.preventDefault();
  //   } else if ( numFormat.length === 1 && e.key === "0" ) {
  //       e.preventDefault();
  //   } else {
  //     this.searchPhoneNumberStatus = numFormat;
  //   }
  // }

  formatPhoneNumber( event: any ) {
    const tmp = this.searchPhoneNumberStatus.replace(/ /g, '');
    this.searchPhoneNumberStatus = this.dataFormat.checkPhoneNumberdigits(tmp, event);
  }

  onPaste( event: any ) {
    this.dataFormatInput.onPasteUtil( event );
  }

  onStepAtive( activeStep: any ) {
    if ( activeStep === '01' ) {
      this.stepOne = true;
      this.stepTwo = false;
      this.stepThree = false;
      this.isButtonActive = true;
      this.isRejectStatus = false;
      this.isNormalStatus = true;
    } else if ( activeStep === '02' ) {
        this.stepOne = true;
        this.stepTwo = true;
        this.stepThree = false;
        this.isButtonActive = true;
        this.isRejectStatus = false;
        this.isNormalStatus = true;
    } else if ( activeStep === '03' ) {
        this.stepOne = true;
        this.stepTwo = true;
        this.stepThree = true;
        this.isButtonActive = false;
        this.isRejectStatus = false;
        this.isNormalStatus = true;
    } else if ( activeStep === '04' ) {
        this.stepOne = true;
        this.stepTwo = false;
        this.stepThree = false;
        this.isNormalStatus = false;
        this.isRejectStatus = true;
        this.isButtonActive = true;
    }
  }

  getTrackStatusData() {
    this.arrayQrData = [];
    if ( this.searchPhoneNumberStatus === '' ) {
      this.resetField();
    } else {
        let tempData: any;
        const reqTr = new PME0611Req();
        reqTr.body.phoneNumber = this.searchPhoneNumberStatus;
        this.bizServer.httpPost( 'PME0611', reqTr ).subscribe( ( data: any ) => {
          const resTr: any = data as PME0611Res;
          if ( resTr.header.result ) {
            tempData = resTr.body.items;
            if ( tempData !== null ) {
              this.statusData = tempData.map( ( list: any, index: any ) => {
              return { ...list, key: this.onGenerateUniqueKey(index) };
              } );
              this.selectedMerchant = this.statusData[0];
              this.defaultMerchant = this.statusData[0];
              this.merchantRequestDate = ( this.dateTimeFormatService.getDateTimeFormat( this.defaultMerchant.merchantAppDate ) );
              this.merchantStatusStep = String( this.defaultMerchant.merchantAppStatusCode );
              this.merchantApplicationNoData = this.defaultMerchant.merchantAppNo;
              this.onStepAtive( this.defaultMerchant.merchantAppStatusCode );
              this.isPhoneNumber = true;
              this.isPhoneNotFound = false;
            }
          } else {
              this.isPhoneNotFound = true;
              this.isPhoneNumber = false;
          }
      } );
    }
  }

  onSelectMerchantList() {
    this.arrayQrData = [];
    for ( const list of this.statusData ) {
      if ( list.merchantName === this.selectedMerchant.merchantName && this.selectedMerchant.key === list.key ) {
        this.merchantRequestDate = ( this.dateTimeFormatService.getDateTimeFormat( this.selectedMerchant.merchantAppDate ) );
        this.merchantStatusStep = String( this.selectedMerchant.merchantAppStatusCode );
        this.merchantApplicationNoData = this.selectedMerchant.merchantAppNo;
        this.onStepAtive( this.selectedMerchant.merchantAppStatusCode );
      }
    }
  }

  onClickDownloadQRImage() {
    const reqTr = new PME0612Req();
    reqTr.body.merchantApplicationNo = this.merchantApplicationNoData;
    this.bizServer.httpPost( 'PME0612', reqTr ).subscribe( ( data: any ) => {
      const resTr = data as PME0612Res;
      if ( this.bizServer.checkResponse( resTr ) ) {
        this.myData = resTr.body.items;
        this.myData.forEach( items => {
          // function generate Qr code
          const qr: any = QRCode( 0, 'L' );
          qr.addData( items.qrData );
          qr.make();
          const canvas: any = document.createElement( 'canvas' );
          const ctx: any = canvas.getContext( '2d' );
          canvas.width = canvas.height = 450;
          ctx.fillStyle = '#fff';
          ctx.fillRect( 0, 0, canvas.width, canvas.height );
          const image = new Image();
          image.src = qr.createDataURL( 4, 0 );
          image.onload = () => {
            ctx.drawImage(image, 20, 20, canvas.width - 40, canvas.height - 40);
            ctx.fillRect(0, 0, canvas.width, 1);
            ctx.fillRect(0, canvas.height - 1, canvas.width, 1);
            items.qrData = canvas.toDataURL();

            // function Download QR Image
            const link = this.renderer.createElement( 'a' );
            this.imageService.makeKHQRImageToBase64( items.qrData, items.currencyCode, items.merchantName, items.merchantId ).then( ( resBase64Data: any ) => {
              link.href = 'data:image/png;base64,' + resBase64Data.slice(resBase64Data.indexOf(',') + 1);
              link.download = 'Merchant_KHQR_IMAGE_' + items.currencyCode;
              this.renderer.appendChild(document.body, link);
              link.click();
            } );
          };
        } );
      }
    } );
  }

  onGenerateUniqueKey( seed: number ) {
    return seed + Math.floor( Math.random() * 900000 ) + 100000;
  }

  resetField() {
    this.stepOne = false;
    this.stepTwo = false;
    this.stepThree = false;
    this.isButtonActive = true;
    this.merchantRequestDate = '';
    this.isPhoneNotFound = false;
    this.isPhoneNumber = false;
    this.statusData = null;
  }
}
